import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: [],
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    signUp: (state, action) => {
      return {
        ...state,
        user: { email: action.payload },
      };
    },

    loginIn: (state, action) => {
      return {
        ...state,
        user: { data: action.payload },
      };
    },
    createSellerAccount: (state, action) => {
      const { data } = state.user;
      const { roles } = data;
      return {
        ...state,
        user: {
          data: { ...data, roles: [...roles, action.payload] },
        },
      };
    },
  },
});

export const { signUp, loginIn, createSellerAccount } = userSlice.actions;
export default userSlice.reducer;
